export default () => {
  const route = useRoute();

  return computed(() => route.name?.toString().startsWith("index"));
};
